type LocalizedText = { lang: string; text: string };

/**
 * Same chain as the server resolver (`build-disapproval.ts`): exact locale, then
 * base language, then English, then any wording at all.
 *
 * Each step matches exactly: folding exact and base into one comparison would
 * let a `pt-br` entry win over the `pt` the server picks, sending the customer a
 * wording the merchant never chose for them.
 */
export function resolveReasonMessage(
  message: LocalizedText[],
  lang: string,
): string {
  const textFor = (locale: string) =>
    message
      .find((entry) => entry.lang.toLowerCase() === locale.toLowerCase())
      ?.text.trim() ?? "";

  return (
    textFor(lang) ||
    textFor(lang.split("-")[0]) ||
    textFor("en") ||
    message.find((entry) => entry.text.trim())?.text.trim() ||
    ""
  );
}
